import { type CSSProperties } from 'typestyle/lib/types';
import rectangularBillboard from '../../../assets/images/rectangularBillboard.png';
import StyleConstants from '../../../core/styles.constants';

export const columnHeader: CSSProperties = {
  wordBreak: 'break-word',
  marginBottom: 8,
  fontSize: StyleConstants.HEADER_FONT_SIZE,
  fontWeight: StyleConstants.HEADER_FONT_WEIGHT,
  fontFamily: StyleConstants.HEADER_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const button: CSSProperties = {
  marginTop: 8,
};

export const officeManagerCreateButton = (isMobile: boolean): CSSProperties => ({
  marginTop: isMobile ? 24 : undefined,
  marginBottom: isMobile ? 12 : undefined,
});

export const columnOfficeManagerHeader = (isMobile: boolean, marginBottom?: number): CSSProperties => ({
  width: '100%',
  wordBreak: 'break-word',
  textAlign: isMobile ? 'center' : undefined,
  fontSize: StyleConstants.HEADER_FONT_SIZE,
  fontWeight: StyleConstants.HEADER_FONT_WEIGHT,
  fontFamily: StyleConstants.HEADER_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  marginBottom,
});

export const bodyMargin = (isMobile: boolean): CSSProperties => ({
  marginLeft: isMobile ? 16 : 56,
  marginRight: isMobile ? 16 : 56,
  marginTop: isMobile ? 16 : 33,
});

export const registerBackground: CSSProperties = {
  height: '100%',
  backgroundImage: `url(${rectangularBillboard})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed',
};

export const card = (isMobile: boolean): CSSProperties => ({
  width: isMobile ? '90%' : 350,
  padding: isMobile ? 24 : 32,
  position: 'absolute',
  left: isMobile ? '50%' : '75%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  background: StyleConstants.WHITE_COLOR,
  boxShadow: '1px 2px 15px rgba(0, 0, 0, 0.1)',
  borderRadius: 8,
});

export const officeManagerCard = (isMobile: boolean, width?: number): CSSProperties => ({
  marginTop: 12,
  marginBottom: 12,
  padding: isMobile ? 12 : 24,
  background: StyleConstants.WHITE_COLOR,
  boxShadow: '1px 2px 15px rgba(0, 0, 0, 0.1)',
  borderRadius: 8,
  width: isMobile ? '100%' : width ?? '100%',
});

export const dropDown: CSSProperties = {
  cursor: 'pointer',
  marginTop: 8,
  marginBottom: 8,
  paddingLeft: 12,
  paddingRight: 12,
  paddingTop: 10,
  paddingBottom: 10,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  background: StyleConstants.WHITE_COLOR,
  border: '1px solid rgba(36, 55, 75, 0.2)',
  borderRadius: 8,
};

export const emptyListMessage: CSSProperties = {
  wordBreak: 'break-word',
  lineBreak: 'strict',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const rowItem = (isLastItem = false): CSSProperties => ({
  marginBottom: isLastItem ? 0 : 12,
  width: '100%',
});

export const gridRow: CSSProperties = {
  marginTop: 12,
};

export const pageMargin: CSSProperties = {
  marginTop: 50,
  marginBottom: 24,
};
